export default {
  getAdminTimeLog: (inspectorNumber, payPeriodId) => `/admin-logs/inspector/${inspectorNumber}/pay-period/${payPeriodId}`,
  addEditDeleteAdminTimeLog: () => `/admin-logs`,
  getAdminWorkTypes: (inspectorNumber) => `/admin-logs/inspector/${inspectorNumber}/work-types`,
};